import React from "react";
import { Bar } from "./NpdShared";
import { countByStatus } from "./npdUtils";

// Supplier master data with part counts, sorted by delayed parts
const Suppliers = ({ app }) => {
  const { suppliers, parts } = app;
  const rows = suppliers
    .map((s) => {
      const c = countByStatus(parts.filter((p) => p.supplierId === s.id));
      return { s, c, t: c.reduce((a, b) => a + b, 0) };
    })
    .sort((a, b) => b.c[3] - a.c[3] || b.t - a.t || a.s.name.localeCompare(b.s.name));

  return (
    <>
      <h2>Suppliers</h2>
      <p className="sub">{rows.length} suppliers, sorted by delayed parts</p>
      <div className="panel">
        <div className="wrap">
          {rows.length ? (
            <table>
              <thead>
                <tr>
                  <th>Supplier</th><th>Parts</th><th>In progress</th><th>Review</th><th>Delayed</th>
                  <th>Completed</th><th style={{ width: 180 }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.s.id}>
                    <td>{r.s.name}</td><td>{r.t}</td><td>{r.c[0]}</td><td>{r.c[2]}</td>
                    <td className={r.c[3] ? "red" : ""}>{r.c[3]}</td><td>{r.c[1]}</td>
                    <td><Bar counts={r.c} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <div className="empty">No suppliers yet. Buyers add suppliers from the Add Part form.</div>}
        </div>
      </div>
    </>
  );
};

export default Suppliers;
